/* unplugin-vue-components disabled */import { render } from "./MockMenuBox.vue?vue&type=template&id=28d47948"
import script from "./MockMenuBox.vue?vue&type=script&lang=js"
export * from "./MockMenuBox.vue?vue&type=script&lang=js"

import "./MockMenuBox.vue?vue&type=style&index=0&id=28d47948&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__